import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/image copy copy.png" alt="Illinois Touch of Family Healthcare LLC" className="footer-logo" />
            <p className="footer-text">
              Providing compassionate healthcare to families across Illinois
            </p>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <nav className="footer-nav">
              <a href="#home" className="footer-link">Home</a>
              <a href="#services" className="footer-link">Services</a>
              <a href="#about" className="footer-link">About</a>
              <a href="#contact" className="footer-link">Contact</a>
            </nav>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <p className="footer-text">
              Phone: (708) 627-9504<br />
              Email: cawondaw@gmail.com
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Illinois Touch of Family Healthcare LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
